import React from "react";
import {
  t,
  HEADING1,
  HEADING2_1,
  HEADING2_2,
  HEADING2_3,
  HEADING2_4,
  CIRCULAR_GSO_NO,
  DOWNLOAD_FILE,
  IT_POLICY,
  IT_POLICY_DOWNLOAD,
  CIRCULAER_1_2020,
  LOCKDOWN_ORDER,
  OFFICE_ORDER,
  DATED,
} from "../../translations/AboutUs/LettersNCirculars";

function LettersNCirculars() {
  return (
    <div className="lettersNCirculars">
      <div className="letters-color-section">
        <h3 className="letters-color-section-main-heading">{t(HEADING1)}</h3>
        <div className="letters-color-section-sub-heading-section">
          {window.lang == "en" ? (
            <React.Fragment>
              <h5 className="letters-color-section-sub-heading">
                {t(HEADING2_1)}
                <a href="Click Here"> {t(HEADING2_2)}</a> {t(HEADING2_3)}
              </h5>
              <span>{t(HEADING2_4)}</span>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <h5 className="letters-color-section-sub-heading">
                {t(HEADING2_1)} <span>{t(HEADING2_2)}</span> {t(HEADING2_3)}
              </h5>
              <a href="Click Here"> {t(HEADING2_4)}</a>
            </React.Fragment>
          )}
        </div>
        <div className="letters-color-section-table-section">
          <table>
            <tr>
              <th>Sl No.</th>
              <th>{t(CIRCULAR_GSO_NO)}</th>
              <th>{t(DOWNLOAD_FILE)}</th>
            </tr>

            <tr>
              <td>1</td>
              <td>{t(IT_POLICY)}</td>
              <td className="td-third">{t(IT_POLICY)}</td>
            </tr>
            <tr>
              <td>2</td>
              <td>{t(CIRCULAER_1_2020)}</td>
              <td className="td-third">{t(CIRCULAER_1_2020)}</td>
            </tr>
            <tr>
              <td>3</td>
              <td>{t(LOCKDOWN_ORDER)}</td>
              <td className="td-third">{t(LOCKDOWN_ORDER)}</td>
            </tr>
            <tr>
              <td>4</td>
              <td>1677</td>
              <td className="td-third">1677</td>
            </tr>
            <tr>
              <td>5</td>
              <td>
                {t(OFFICE_ORDER)} A1-11/001/2020-21, {t(DATED)} 16-04-2020
              </td>
              <td className="td-third">
                {t(OFFICE_ORDER)} A1-11/001/2020-21,Dated 16-04-2020
              </td>
            </tr>
            <tr>
              <td>6</td>
              <td>
                {t(OFFICE_ORDER)} A1-11/1258,{t(DATED)} 15-04-2020
              </td>
              <td className="td-third">
                {t(OFFICE_ORDER)} A1-11/1258,{t(DATED)} 15-04-2020
              </td>
            </tr>
            <tr>
              <td>7</td>
              <td>
                {t(OFFICE_ORDER)} 318,{t(DATED)} 09-03-2020
              </td>
              <td className="td-third">
                {t(OFFICE_ORDER)} 318,{t(DATED)} 09-03-2020
              </td>
            </tr>
            <tr>
              <td>8</td>
              <td>1672</td>
              <td className="td-third">1672</td>
            </tr>
            <tr>
              <td>9</td>
              <td>1671</td>
              <td className="td-third">1671</td>
            </tr>
            <tr>
              <td>10</td>
              <td>2352</td>
              <td className="td-third">2352</td>
            </tr>
            <tr>
              <td>11</td>
              <td>2353</td>
              <td className="td-third">2353</td>
            </tr>
            <tr>
              <td>12</td>
              <td>1667</td>
              <td className="td-third">1667</td>
            </tr>
            <tr>
              <td>13</td>
              <td>1669</td>
              <td className="td-third">1669</td>
            </tr>
            <tr>
              <td>14</td>
              <td>1657</td>
              <td className="td-third">1657</td>
            </tr>
            <tr>
              <td>15</td>
              <td>1663</td>
              <td className="td-third">1663</td>
            </tr>
            <tr>
              <td>16</td>
              <td>1668</td>
              <td className="td-third">1668</td>
            </tr>
            <tr>
              <td>17</td>
              <td>GSO-788</td>
              <td className="td-third">GSO-788</td>
            </tr>
            <tr>
              <td>18</td>
              <td>GSO-787</td>
              <td className="td-third">GSO-787</td>
            </tr>
            <tr>
              <td>19</td>
              <td>1429</td>
              <td className="td-third">1429</td>
            </tr>
            <tr>
              <td>20</td>
              <td>1513</td>
              <td className="td-third">1513</td>
            </tr>
            <tr>
              <td>21</td>
              <td>1425</td>
              <td className="td-third">1425</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  );
}

export default LettersNCirculars;
